//@ts-nocheck


import { Component, OnDestroy, OnInit, Input, Optional, OnChanges, SimpleChanges } from '@angular/core';
import { MapComponent } from '../map.component';
import { Vector } from 'ol/layer';
import { Style } from 'ol/style';
import { StyleFunction } from 'ol/style/Style';
import { LayerComponent } from './layer.component';
import { LayerGroupComponent } from './layergroup.component';

@Component({
  selector: 'aol-layer-vector',
  template: ` <ng-content></ng-content> `,
})
export class LayerVectorComponent extends LayerComponent implements OnInit, OnDestroy, OnChanges {
  public source: Vector;

  @Input()
  renderBuffer: number;

  @Input()
  style: Style | Style[] | StyleFunction;

  @Input()
  updateWhileAnimating: boolean;

  @Input()
  updateWhileInteracting: boolean;

  @Input()
  id: string | number | undefined;

  @Input()
  visible: boolean;

  @Input()
  zIndex: number;

  constructor(map: MapComponent, @Optional() group?: LayerGroupComponent) {
    super(group || map);
  }

  ngOnInit() {
    // console.log('creating ol.layer.Vector instance with:', this);
    this.instance = new Vector(this);
    if (this.id !== undefined) {
      this.instance.setProperties({'id': this.id});
    }
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.instance) {
      this.instance.setProperties({'id': this.id});
    }

    super.ngOnChanges(changes);
  }
}
